<template>
  <div>
    <AddModules />
  </div>
</template>

<script>
import AddModules from './AddModules.vue';
export default {
  components: {
    AddModules
  }
}
</script>
